export const SocialData = [
    {
        platform : "twitter",
        link : "https://twitter.com/home",
        icon : require("../../profile/pp2/connection.png")
    }, 

    {
        platform : "linkedin",
        link : "https://www.linkedin.com/in/abhishek-kasera-50180321a/",
        icon : require("../../profile/pp2/linkedin.png")
    },

    {
        platform : "whatsapp",
        link : "https://wa.me/+919169111377 ",
        icon : require("../../profile/pp2/whatsapp.png")
    },

    {
        platform : "github",
        link : "https://github.com/AbhishekKasera7696 ",
        icon : require("../../profile/pp2/github.png")
    },

    {
        platform : "gmail",
        link : "mailto:abhi07kasera@gmail.com",
        icon : require("../../profile/pp2/gmail.png")
    },
    
    
]